const errorMessages = {
  EC_Procedure_In_Use: "Процедурата е активна и не може да бъде изтрита!",
  EC_Thematic_Catalog_Is_Used: "Темата се ползва от издание и не може да бъде изтрита!",
  EC_Thematic_Catalog_Is_Currently_Active: "Темата е активна и не може да бъде изтрита!",
  "An error occurred while saving the entity changes. See the inner exception for details.": "Възникна грешка!",
  EC_News_Type_Is_Not_Correct: "Формата не е попълнена правилно",
  EC_Invalid_Content: "Моля попълнете полето с описание на новина",
  EC_Invoice_Elements_Cannot_Be_Empty: "Въведете данни за фактура.",
  // EC_Campaign_Is_Taken: "Въведените дати за кампания са заети",
  EC_Campaign_Is_Taken: "Грешен период на действие!",
  EC_Invalid_Theme: "Невалидна тема. Моля изберете от падащото меню!",
  EC_Thematic_Catalog_Not_Found: "Темите не отговарят на тематичния каталог!",
  EC_File_Must_Be_Correct: "Грешен формат на файла !",
  EC_Order_Messages_Cannot_Be_Null: "Трябва да въведете поне едно съобщение",
  default: "Възникна грешка, моля опитайте по-късно!",
};
export default errorMessages;
